// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import { setItem, getItem } from '../utils/storage'
import Constant from '../common/Constant'
import status from './modules/im/status'
import imModule from './modules/im/'

Vue.use(Vuex)

export const getCompanyConfig = () => {
    const map = [
        {
            themeClassName: 'xiaozhi',
            themeColor: '#00AE66',
            suffixUrl: '',
            appId: 1,
            companyGuid: '',
            appName: '名盛房产'
        },
        {
            themeClassName: 'tiantian',
            themeColor: '#9a0000',
            suffixUrl: '/tiantian',
            appId: 3,
            companyGuid: '95ba4e1747bf11ea95a700163e068943',
            appName: '天天选房'
        },
        {
            themeClassName: 'tiancheng',
            themeColor: '#043790',
            suffixUrl: '/tiancheng',
            appId: 4,
            companyGuid: 'df9804477ac11edaf4a00163e3670e0',
            appName: '甜城找房'
        },
    ]
    const current = map.find(_ => _.companyGuid === Constant.DEFAULT_COMPANY_GUID)
    return current
}

export default new Vuex.Store({
    state: {
        user: getItem(Constant.CUSTOMER),
        showLogin: false,
        showSearchTip: false,
        searchRecords: getItem(Constant.SEARCH_RECORDS) || [],
        location: getItem(Constant.CHOOSELOCATION) || {
            cityCode: Constant.DEFAULT_CITY_CODE,
            cityName: Constant.DEFAULT_CITY_NAME,
            latitude: Constant.DEFAULT_CITY_LAT,
            longitude: Constant.DEFAULT_CITY_LNG
        },
        defaultRealHouseName: "真房源",
        companyConfig: {
            tel: '028 6463 6764',
            firstName: '名盛',
            lastName: '房产',
            whiteLogo: Constant.IMG_ICON_URL + '/msfcwritelog.png',
            greenLogo: Constant.IMG_ICON_URL + '/msfcGreenLog.png',
            downloadUrl: Constant.IMG_BASE + '/xiaozhizhaofang.png',
            miniLogo: Constant.IMG_ICON_URL + '/msfcwritelog.png',
            webSiteInfo: {
                name: '',
                address: '',
                filing: ' ',
                date: '',
                webName: ''
            },
            ...getCompanyConfig()
        },
        cityCompany: getItem(Constant.CITY_COMPANY) || {},
        isGetLocation: getItem(Constant.IS_GET_LOCATION),
        isRefreshPage: getItem(Constant.IS_REFRESH_PAGE),
        isSourceERP: getItem(Constant.IS_SORCE_ERP) || false
    },
    mutations: {
        updateState(state, { data, key }) {
            state[key] = data
        },
        saveLocation(state, data) {
            state.location = data
            setItem(Constant.CHOOSELOCATION, state.location)
        },
        saveUser(state, data) {
            state.user = data
            setItem(Constant.CUSTOMER, state.user)
            setItem(Constant.ACCESSTOKEN, state.user?.accessToken)
        },
        saveSearchRecords(state, data) {
            state.searchRecords = data
            setItem(Constant.SEARCH_RECORDS, state.searchRecords)
        }
    },
    actions: {
        // 根级别的 actions 为空，所有 IM 相关的都在 im 模块中
    },
    modules: {
        im: imModule,
        status
    }
})